export const GET_MYJOBS_REQUEST = "GET_MYJOBS_REQUEST";
export const GET_MYJOBS_SUCCESS = "GET_MYJOBS_SUCCESS";
export const GET_MYJOBS_FAILURE = "GET_MYJOBS_FAILURE";

export const POST_MYJOBS_REQUEST = "POST_MYJOBS_REQUEST";
export const POST_MYJOBS_SUCCESS = "POST_MYJOBS_SUCCESS";
export const POST_MYJOBS_FAILURE = "POST_MYJOBS_FAILURE";

export const UPDATE_FILTERED_JOBS = "UPDATE_FILTERED_JOBS";
